import React, { Component } from "react";
import "../../css/ScaleButton.css";
import { connect } from "react-redux";
import { scaleProduct } from "../../models";

class ScaleButton extends Component {
  scaleCol = () => {
    // 一列兩個
    this.props.startScaleProduct(false);
  };
  scaleRow = () => {
    // 一列一個
    this.props.startScaleProduct(true);
  };
  render() {
    return (
      <div className="content-wrapper-wider d-block d-md-none scale-button-wrap">
        <a
          className={`scale-button ${!this.props.scale ? "active" : ""}`}
          onClick={this.scaleCol}
        >
          <span className="scale-button-stroke"></span>
          <span className="scale-button-stroke"></span>
        </a>
        <a
          className={`scale-button ${this.props.scale ? "active" : ""}`}
          onClick={this.scaleRow}
        ></a>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    scale: state.scaleProduct.scale
  };
};

const mapDispatchToProps = () => {
  return {
    startScaleProduct: bool => scaleProduct.actions.startScaleProduct(bool)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScaleButton);
